<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col
        v-if="$router.history.current.query.purchaseOffer != null"
        cols="12"
        xl="9"
        md="8"
      >
        <b-form @submit.prevent>
          <b-card no-body class="invoice-preview-card">
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="
                  d-flex
                  justify-content-between
                  flex-md-row flex-column
                  invoice-spacing
                  mt-0
                "
              >
                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <logo />
                    <h3 class="text-primary invoice-logo">ERP NewTech</h3>
                  </div>
                  <b-card-text class="mb-25">
                    {{ user.adress }}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{ user.ville }}, {{ user.city }}, {{ user.postalCode }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ user.PhoneNumber }}
                  </b-card-text>
                </div>

                <!-- Header: Right Content -->
                <div class="invoice-number-date mt-md-0 mt-2">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-md-end
                      mb-1
                    "
                  >
                    <h4 class="invoice-title">Dev N°</h4>
                    <b-input-group
                      class="
                        input-group-merge
                        invoice-edit-input-group
                        disabled
                      "
                    >
                      <b-input-group-prepend is-text>
                        <feather-icon icon="HashIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="invoice-data-id"
                        v-model="quoteData.offers.toUpdate.code"
                        disabled
                      />
                    </b-input-group>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <span class="title"> Date de création: </span>
                    <flat-pickr
                      v-model="quoteData.offers.toUpdate.createdAt"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title"> Date limite: </span>
                    <flat-pickr
                      v-model="quoteData.offers.toUpdate.date"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Invoice supplier & Payment Details -->
            <b-card-body class="invoice-padding pt-0">
              <b-row class="invoice-spacing">
                <!-- Col: Invoice To -->
                <b-col cols="12" xl="6" class="mb-lg-1">
                  <h6 class="mb-2">Devis de:</h6>

                  <!-- Select supplier -->
                  <v-select
                    id="item-supplier"
                    v-model="quoteData.offers.toUpdate.supplier"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    placeholder="Nom du Fournisseur"
                    :options="suppliers"
                    @input="getSupplierDetail(supplier)"
                  >
                    <template #list-header>
                      <li
                        v-b-toggle.sidebar-add-new-supplier
                        class="add-new-header d-flex align-items-center my-50"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25"
                          >Ajouter un Fournisseur</span
                        >
                      </li>
                    </template>
                  </v-select>

                  <!-- Selected supplier -->
                  <div v-if="supplier" class="mt-1">
                    <h6 class="mb-25">
                      {{ supplier.firstName }} {{ supplier.lastName }}
                    </h6>
                    <!-- <b-card-text class="mb-25">
                      {{ supplier.company }}
                    </b-card-text> -->
                    <b-card-text
                      class="mb-25"
                      v-if="supplier.address && supplier.city"
                    >
                      {{ supplier.address }},
                      {{ supplier.city }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ supplier.email }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ supplier.telNumbers }}
                    </b-card-text>
                  </div>
                </b-col>

                <!-- Col: Payment Details -->
                <b-col
                  xl="6"
                  cols="12"
                  class="mt-xl-0 mt-2 justify-content-end d-xl-flex d-block"
                >
                  <div>
                    <h6 class="mb-2">Détails paiement:</h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">Nom du bank :</td>
                          <td>Biat</td>
                        </tr>
                        <tr>
                          <td class="pr-1">Pays:</td>
                          <td>Tunisie</td>
                        </tr>
                        <tr>
                          <td class="pr-1">IBAN:</td>
                          <td>ETD95476213874685</td>
                        </tr>
                        <tr>
                          <td class="pr-1">code SWIFT:</td>
                          <td>BR91905</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Items Section -->
            <b-card-body class="invoice-padding form-item-section">
              <div ref="form" class="repeater-form" v-if="items.length > 0">
                <!-- old items -->
                <b-row
                  v-for="(item, index) in items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->

                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <b-col cols="12" lg="5"> Désignation </b-col>
                        <b-col cols="12" lg="3"> Coût </b-col>
                        <b-col cols="12" lg="2">
                          <select
                            id="item-name"
                            v-model="item.quantityType"
                            label="title"
                            placeholder="Nom du produit"
                            class="select-quantity-type"
                          >
                            <option selected>Quantité(s)</option>
                            <option>Heure(s)</option>
                          </select>
                        </b-col>
                        <b-col cols="12" lg="2"> Prix </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col cols="12" lg="5">
                          <label class="d-inline d-lg-none">Item</label>
                          <v-select
                            id="item-name"
                            v-model="item.name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="title"
                            :options="products"
                            @input="getProductDetail(item)"
                            placeholder="Nom du produit"
                          >
                            <!-- return {
                quantity: product.quantity,
                quantityType: product.quantityType,
                description: product.product.description,
                price: product.product.valueAddedTax,
                discount: product.product.discount,
                tax: product.valueAddedTax,
                label: product.product.label,
              }; -->
                            <template #list-header>
                              <li
                                v-b-toggle.sidebar-add-new-product
                                class="
                                  add-new-header
                                  d-flex
                                  align-items-center
                                  my-50
                                "
                              >
                                <feather-icon icon="PlusIcon" size="16" />
                                <span class="align-middle ml-25"
                                  >Ajouter un produit</span
                                >
                              </li>
                            </template>
                          </v-select>
                          <!-- @input="(val) => updateItemForm(index, val)" -->
                        </b-col>
                        <b-col cols="12" lg="3">
                          <label class="d-inline d-lg-none">Cost</label>
                          <b-form-input
                            v-model="item.price"
                            type="number"
                            class="mb-2"
                            @input="getNewResult(item)"
                          />
                        </b-col>
                        <b-col cols="12" lg="2">
                          <label class="d-inline d-lg-none">QTÉ </label>
                          <b-form-input
                            v-model="item.quantity"
                            type="number"
                            class="mb-2"
                            @input="
                              productPricingChange(item), getNewResult(item)
                            "
                          />
                        </b-col>
                        <b-col cols="12" lg="2">
                          <label class="d-inline d-lg-none">Price</label>
                          <p class="mb-1">
                            {{ item.price * item.quantity || 0 }}
                            {{ externalUserCurrency() }}
                          </p>
                        </b-col>
                        <b-col cols="12" lg="5">
                          <label class="d-inline d-lg-none">Description</label>
                          <b-form-textarea
                            v-model="item.description"
                            class="mb-2 mb-lg-0"
                          />
                        </b-col>
                        <b-col>
                          <p class="mb-0">
                            Remise: {{ item.discount }}%, Tax: {{ item.tax }}%
                          </p>
                        </b-col>
                      </b-row>
                      <div
                        class="
                          d-flex
                          flex-column
                          justify-content-between
                          border-left
                          py-50
                          px-25
                        "
                      >
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeItem(index)"
                        />
                        <feather-icon
                          :id="`form-item-settings-icon-${index}`"
                          size="16"
                          icon="SettingsIcon"
                          class="cursor-pointer"
                        />

                        <!-- Setting Item Form -->
                        <b-popover
                          :ref="`form-item-settings-popover-${index}`"
                          :target="`form-item-settings-icon-${index}`"
                          triggers="click"
                          placement="lefttop"
                        >
                          <b-form @submit.prevent>
                            <b-row>
                              <!-- Field: Discount -->
                              <b-col cols="12">
                                <b-form-group
                                  label="Remise(%)"
                                  :label-for="`setting-item-${index}-discount`"
                                >
                                  <b-form-input
                                    :id="`setting-item-${index}-discount`"
                                    v-model="item.discount"
                                    type="number"
                                    @input="getNewResult(item)"
                                  />
                                </b-form-group>
                              </b-col>

                              <!-- Field: Tax 1 -->
                              <b-col cols="12">
                                <b-form-group
                                  label="Tax(%)"
                                  :label-for="`setting-item-${index}-tax-1`"
                                >
                                  <b-form-input
                                    :id="`setting-item-${index}-discount`"
                                    v-model="item.tax"
                                    type="number"
                                    @input="getNewResult(item)"
                                  />
                                  <!-- <v-select
                                    :dir="
                                      $store.state.appConfig.isRTL
                                        ? 'rtl'
                                        : 'ltr'
                                    "
                                    :value="'10%'"
                                    :options="['0%', '1%', '10%', '14%', '18%']"
                                    :input-id="`setting-item-${index}-tax-1`"
                                    :clearable="false"
                                  /> -->
                                </b-form-group>
                              </b-col>

                              <b-col
                                cols="12"
                                class="d-flex justify-content-between mt-1"
                              >
                                <b-button
                                  variant="outline-primary"
                                  @click="
                                    () => {
                                      $refs[
                                        `form-item-settings-popover-${index}`
                                      ][0].$emit('close');
                                    }
                                  "
                                >
                                  Appliquer
                                </b-button>
                                <b-button
                                  variant="outline-secondary"
                                  @click="
                                    () => {
                                      $refs[
                                        `form-item-settings-popover-${index}`
                                      ][0].$emit('close');
                                    }
                                  "
                                >
                                  Annuler
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-form>
                        </b-popover>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItemInItemForm"
              >
                Ajouter un produit
              </b-button>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col cols="12" md="6">
                  <!-- class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1" -->
                  <h6 for="invoice-data-sales-person" class="text-nowrap mr-50">
                    Vendeur:
                  </h6>
                  <!-- <b-form-input
                    id="invoice-data-sales-person"
                    value="user test"
                    placeholder="Administrateur"
                  /> -->
                  <v-select
                    id="item-name"
                    v-model="quoteData.offers.toUpdate.createdBy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="fullName"
                    :options="salesPersonne"
                    placeholder="Nom du vendeur"
                  >
                    <template #list-header>
                      <li
                        class="add-new-header d-flex align-items-center my-50"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25"
                          >Ajouter un vendeur</span
                        >
                      </li>
                    </template>
                  </v-select>
                  <!-- @input="(val) => updateItemForm(index, val)" -->
                </b-col>
                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="12"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Timbre:</p>
                      <b-form-input
                        class="width-50"
                        v-model="quoteData.offers.toUpdate.stampPrice"
                        type="number"
                        @input="geTotalNewResult()"
                      />
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale HT:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toUpdate.priceWithoutTaxes }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Tax:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toUpdate.valueAddedTax }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale av tax:</p>
                      <p class="invoice-total-amount">
                        {{
                          quoteData.offers.toUpdate.valueAddedTax +
                          quoteData.offers.toUpdate.priceWithoutTaxes
                        }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Remise:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toUpdate.totalDiscount }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <hr class="my-50" />
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale TTC:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toUpdate.allTaxesIncluded }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0" v-if="noteInvoice">
              <span class="font-weight-bold">Note: </span>
              <b-form-textarea v-model="quoteData.offers.toUpdate.note" />
            </b-card-body>

            <!-- Terme de paiement -->
            <b-card-body class="invoice-padding pt-0" v-if="rateInvoice">
              <span class="font-weight-bold">Terme de paiement: </span>
              <b-form-textarea
                v-model="quoteData.offers.toUpdate.paymentTerms"
              />
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>
      <b-col v-else cols="12" xl="9" md="8">
        <b-form @submit.prevent>
          <b-card no-body class="invoice-preview-card">
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">
              <div
                class="
                  d-flex
                  justify-content-between
                  flex-md-row flex-column
                  invoice-spacing
                  mt-0
                "
              >
                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <logo />
                    <h3 class="text-primary invoice-logo">ERP NewTech</h3>
                  </div>
                  <b-card-text class="mb-25">
                    {{ user.adress }}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{ user.ville }}, {{ user.city }}, {{ user.postalCode }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ user.PhoneNumber }}
                  </b-card-text>
                </div>

                <!-- Header: Right Content -->
                <div class="invoice-number-date mt-md-0 mt-2">
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-md-end
                      mb-1
                    "
                  >
                    <h4 class="invoice-title">Dev N°</h4>
                    <b-input-group
                      class="
                        input-group-merge
                        invoice-edit-input-group
                        disabled
                      "
                    >
                      <b-input-group-prepend is-text>
                        <feather-icon icon="HashIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="invoice-data-id"
                        v-model="quoteData.offers.toAdd.code"
                        disabled
                      />
                    </b-input-group>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <span class="title"> Date de création: </span>
                    <flat-pickr
                      v-model="quoteData.offers.toAdd.createdAt"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="title"> Date limite: </span>
                    <flat-pickr
                      v-model="quoteData.offers.toAdd.date"
                      class="form-control invoice-edit-input"
                    />
                  </div>
                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Invoice supplier & Payment Details -->
            <b-card-body class="invoice-padding pt-0">
              <b-row class="invoice-spacing">
                <!-- Col: Invoice To -->
                <b-col cols="12" xl="6" class="mb-lg-1">
                  <h6 class="mb-2">Devis de:</h6>

                  <!-- Select supplier -->
                  <v-select
                    id="item-supplier"
                    v-model="quoteData.offers.toAdd.supplier"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    placeholder="Nom du Fournisseur"
                    :options="suppliers"
                    @input="getSupplierDetail(supplier)"
                  >
                    <template #list-header>
                      <li
                        v-b-toggle.sidebar-add-new-supplier
                        class="add-new-header d-flex align-items-center my-50"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25"
                          >Ajouter un Fournisseur</span
                        >
                      </li>
                    </template>
                  </v-select>

                  <!-- Selected supplier -->
                  <div v-if="supplier" class="mt-1">
                    <h6 class="mb-25">
                      {{ supplier.firstName }} {{ supplier.lastName }}
                    </h6>
                    <!-- <b-card-text class="mb-25">
                      {{ supplier.company }}
                    </b-card-text> -->
                    <b-card-text
                      class="mb-25"
                      v-if="supplier.address && supplier.city"
                    >
                      {{ supplier.address }},
                      {{ supplier.city }}
                    </b-card-text>
                    <b-card-text class="mb-25">
                      {{ supplier.email }}
                    </b-card-text>
                    <b-card-text class="mb-0">
                      {{ supplier.telNumbers }}
                    </b-card-text>
                  </div>
                </b-col>

                <!-- Col: Payment Details -->
                <b-col
                  xl="6"
                  cols="12"
                  class="mt-xl-0 mt-2 justify-content-end d-xl-flex d-block"
                >
                  <div>
                    <h6 class="mb-2">Détails paiement:</h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">Nom du bank :</td>
                          <td>Biat</td>
                        </tr>
                        <tr>
                          <td class="pr-1">Pays:</td>
                          <td>Tunisie</td>
                        </tr>
                        <tr>
                          <td class="pr-1">IBAN:</td>
                          <td>ETD95476213874685</td>
                        </tr>
                        <tr>
                          <td class="pr-1">code SWIFT:</td>
                          <td>BR91905</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Items Section -->
            <b-card-body class="invoice-padding form-item-section">
              <div ref="form" class="repeater-form" v-if="items.length > 0">
                <!-- old items -->
                <b-row
                  v-for="(item, index) in items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >
                  <!-- Item Form -->

                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <b-col cols="12" lg="5"> Désignation </b-col>
                        <b-col cols="12" lg="3"> Coût </b-col>
                        <b-col cols="12" lg="2">
                          <select
                            id="item-name"
                            v-model="item.quantityType"
                            label="title"
                            placeholder="Nom du produit"
                            class="select-quantity-type"
                          >
                            <option selected>Quantité(s)</option>
                            <option>Heure(s)</option>
                          </select>
                        </b-col>
                        <b-col cols="12" lg="2"> Prix </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col cols="12" lg="5">
                          <label class="d-inline d-lg-none">Item</label>
                          <v-select
                            id="item-name"
                            v-model="item.name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            label="title"
                            :options="products"
                            @input="getProductDetail(item)"
                            placeholder="Nom du produit"
                          >
                            <!-- return {
                quantity: product.quantity,
                quantityType: product.quantityType,
                description: product.product.description,
                price: product.product.valueAddedTax,
                discount: product.product.discount,
                tax: product.valueAddedTax,
                label: product.product.label,
              }; -->
                            <template #list-header>
                              <li
                                v-b-toggle.sidebar-add-new-product
                                class="
                                  add-new-header
                                  d-flex
                                  align-items-center
                                  my-50
                                "
                              >
                                <feather-icon icon="PlusIcon" size="16" />
                                <span class="align-middle ml-25"
                                  >Ajouter un produit</span
                                >
                              </li>
                            </template>
                          </v-select>
                          <!-- @input="(val) => updateItemForm(index, val)" -->
                        </b-col>
                        <b-col cols="12" lg="3">
                          <label class="d-inline d-lg-none">Cost</label>
                          <b-form-input
                            v-model="item.price"
                            type="number"
                            class="mb-2"
                            @input="getNewResult(item)"
                          />
                        </b-col>
                        <b-col cols="12" lg="2">
                          <label class="d-inline d-lg-none">QTÉ </label>
                          <b-form-input
                            v-model="item.quantity"
                            type="number"
                            class="mb-2"
                            @input="
                              productPricingChange(item), getNewResult(item)
                            "
                          />
                        </b-col>
                        <b-col cols="12" lg="2">
                          <label class="d-inline d-lg-none">Price</label>
                          <p class="mb-1">
                            {{ item.price * item.quantity || 0 }}
                            {{ externalUserCurrency() }}
                          </p>
                        </b-col>
                        <b-col cols="12" lg="5">
                          <label class="d-inline d-lg-none">Description</label>
                          <b-form-textarea
                            v-model="item.description"
                            class="mb-2 mb-lg-0"
                          />
                        </b-col>
                        <b-col>
                          <p class="mb-0">
                            Remise: {{ item.discount }}%, Tax: {{ item.tax }}%
                          </p>
                        </b-col>
                      </b-row>
                      <div
                        class="
                          d-flex
                          flex-column
                          justify-content-between
                          border-left
                          py-50
                          px-25
                        "
                      >
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeItem(index)"
                        />
                        <feather-icon
                          :id="`form2-item-settings-icon-${index}`"
                          size="16"
                          icon="SettingsIcon"
                          class="cursor-pointer"
                        />

                        <!-- Setting Item Form -->
                        <b-popover
                          :ref="`form2-item-settings-popover-${index}`"
                          :target="`form2-item-settings-icon-${index}`"
                          triggers="click"
                          placement="lefttop"
                        >
                          <b-form @submit.prevent>
                            <b-row>
                              <!-- Field: Discount -->
                              <b-col cols="12">
                                <b-form-group
                                  label="Remise(%)"
                                  :label-for="`setting-item-${index}-discount`"
                                >
                                  <b-form-input
                                    :id="`setting-item-${index}-discount`"
                                    v-model="item.discount"
                                    type="number"
                                    @input="getNewResult(item)"
                                  />
                                </b-form-group>
                              </b-col>

                              <!-- Field: Tax 1 -->
                              <b-col cols="12">
                                <b-form-group
                                  label="Tax(%)"
                                  :label-for="`setting2-item-${index}-tax-1`"
                                >
                                  <b-form-input
                                    :id="`setting2-item-${index}-discount`"
                                    v-model="item.tax"
                                    type="number"
                                    @input="getNewResult(item)"
                                  />
                                  <!-- <v-select
                                    :dir="
                                      $store.state.appConfig.isRTL
                                        ? 'rtl'
                                        : 'ltr'
                                    "
                                    :value="'10%'"
                                    :options="['0%', '1%', '10%', '14%', '18%']"
                                    :input-id="`setting-item-${index}-tax-1`"
                                    :clearable="false"
                                  /> -->
                                </b-form-group>
                              </b-col>

                              <b-col
                                cols="12"
                                class="d-flex justify-content-between mt-1"
                              >
                                <b-button
                                  variant="outline-primary"
                                  @click="
                                    () => {
                                      $refs[
                                        `form2-item-settings-popover-${index}`
                                      ][0].$emit('close');
                                    }
                                  "
                                >
                                  Appliquer
                                </b-button>
                                <b-button
                                  variant="outline-secondary"
                                  @click="
                                    () => {
                                      $refs[
                                        `form2-item-settings-popover-${index}`
                                      ][0].$emit('close');
                                    }
                                  "
                                >
                                  Annuler
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-form>
                        </b-popover>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItemInItemForm"
              >
                Ajouter un produit
              </b-button>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>
                <!-- Col: Sales Persion -->
                <b-col cols="12" md="6">
                  <!-- class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1" -->
                  <h6 for="invoice-data-sales-person" class="text-nowrap mr-50">
                    Vendeur:
                  </h6>
                  <!-- <b-form-input
                    id="invoice-data-sales-person"
                    value="user test"
                    placeholder="Administrateur"
                  /> -->
                  <v-select
                    id="item-name"
                    v-model="quoteData.offers.toAdd.createdBy"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="fullName"
                    :options="salesPersonne"
                    placeholder="Nom du vendeur"
                  >
                    <template #list-header>
                      <li
                        class="add-new-header d-flex align-items-center my-50"
                      >
                        <feather-icon icon="PlusIcon" size="16" />
                        <span class="align-middle ml-25"
                          >Ajouter un vendeur</span
                        >
                      </li>
                    </template>
                  </v-select>
                  <!-- @input="(val) => updateItemForm(index, val)" -->
                </b-col>
                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="12"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Timbre:</p>
                      <b-form-input
                        class="width-50"
                        v-model="quoteData.offers.toAdd.stampPrice"
                        type="number"
                        @input="geTotalNewResult()"
                      />
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale HT:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toAdd.priceWithoutTaxes }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Tax:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toAdd.valueAddedTax }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale av tax:</p>
                      <p class="invoice-total-amount">
                        {{
                          quoteData.offers.toAdd.valueAddedTax +
                          quoteData.offers.toAdd.priceWithoutTaxes
                        }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Remise:</p>
                      <p class="invoice-total-amount">
                        {{ quoteData.offers.toAdd.totalDiscount }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                    <hr class="my-50" />
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">Totale TTC:</p>
                      <p class="invoice-total-amount">
                        {{
                          quoteData.valueAddedTax +
                          quoteData.priceWithoutTaxes -
                          quoteData.totalDiscount +
                          Number.parseFloat(quoteData.stampPrice)
                        }}
                        {{ externalUserCurrency() }}
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
            <!-- Spacer -->
            <hr class="invoice-spacing" />

            <!-- Note -->
            <b-card-body class="invoice-padding pt-0" v-if="noteInvoice">
              <span class="font-weight-bold">Note: </span>
              <b-form-textarea v-model="quoteData.offers.toAdd.note" />
            </b-card-body>

            <!-- Terme de paiement -->
            <b-card-body class="invoice-padding pt-0" v-if="rateInvoice">
              <span class="font-weight-bold">Terme de paiement: </span>
              <b-form-textarea v-model="quoteData.offers.toAdd.paymentTerms" />
            </b-card-body>
          </b-card>
        </b-form>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        v-if="$router.history.current.query.purchaseOffer != null"
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
      >
        <!-- Action Buttons -->
        <b-card>
          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            disabled
          >
            Envoyé devis
          </b-button>

          <!-- Button: DOwnload -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            block
            disabled
          >
            Consulter
          </b-button>

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            block
            @click="openUploadModal()"
          >
            Images
          </b-button>

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            block
            @click="updateQuote()"
          >
            Enregistrer
          </b-button>
        </b-card>

        <!-- Payment Method -->
        <div class="mt-2">
          <b-form-group label="Etat" label-for="Etat">
            <v-select
              id="Etat"
              v-model="quoteData.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="statusName"
              :options="statusOptions"
              :reduce="(status) => status.label"
            />
          </b-form-group>
          <b-form-group label="Type de paiement" label-for="payment-method">
            <v-select
              v-model="quoteData.offers.toUpdate.paymentMethod"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="paymentMethods"
              input-id="payment-method"
              class="payment-selector"
              :clearable="false"
            />
          </b-form-group>

          <!-- ? Below values are not adding quoteData to keep quoteData more generic and less confusing  -->

          <!-- Payment Terms -->
          <div class="d-flex justify-content-between align-items-center">
            <label for="patymentTerms">Terme de paiement</label>
            <b-form-checkbox
              id="patymentTerms"
              :checked="false"
              switch
              @change="noteInvoice = noteInvoice == true ? false : true"
            />
          </div>

          <!-- supplier Notes -->
          <div class="d-flex justify-content-between align-items-center my-1">
            <label for="supplierNotes">Note de Fournisseur</label>
            <b-form-checkbox
              id="supplierNotes"
              :checked="false"
              switch
              @change="rateInvoice = rateInvoice == true ? false : true"
            />
          </div>

          <!-- Payment Stub -->
          <!-- <div class="d-flex justify-content-between align-items-center">
            <label for="paymentStub">Payment Stub</label>
            <b-form-checkbox id="paymentStub" switch />
          </div> -->
        </div>
      </b-col>
      <b-col
        v-else
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
      >
        <!-- Action Buttons -->
        <b-card>
          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            disabled
          >
            Envoyé devis
          </b-button>

          <!-- Button: DOwnload -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            block
            disabled
          >
            Consulter
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            block
            @click="openUploadModal()"
          >
            Images
          </b-button>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            block
            @click="updateQuote()"
          >
            Enregistrer
          </b-button>
        </b-card>

        <!-- Payment Method -->
        <div class="mt-2">
          <b-form-group label="Etat" label-for="Etat">
            <v-select
              id="Etat"
              v-model="quoteData.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="statusName"
              :options="statusOptions"
              :reduce="(status) => status.label"
            />
          </b-form-group>
          <b-form-group label="Type de paiement" label-for="payment-method">
            <v-select
              v-model="quoteData.offers.toAdd.paymentMethod"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="paymentMethods"
              input-id="payment-method"
              class="payment-selector"
              :clearable="false"
            />
          </b-form-group>

          <!-- ? Below values are not adding quoteData to keep quoteData more generic and less confusing  -->

          <!-- Payment Terms -->
          <div class="d-flex justify-content-between align-items-center">
            <label for="patymentTerms">Terme de paiement</label>
            <b-form-checkbox
              id="patymentTerms"
              :checked="false"
              switch
              @change="noteInvoice = noteInvoice == true ? false : true"
            />
          </div>

          <!-- supplier Notes -->
          <div class="d-flex justify-content-between align-items-center my-1">
            <label for="supplierNotes">Note de Fournisseur</label>
            <b-form-checkbox
              id="supplierNotes"
              :checked="false"
              switch
              @change="rateInvoice = rateInvoice == true ? false : true"
            />
          </div>

          <!-- Payment Stub -->
          <!-- <div class="d-flex justify-content-between align-items-center">
            <label for="paymentStub">Payment Stub</label>
            <b-form-checkbox id="paymentStub" switch />
          </div> -->
        </div>
      </b-col>
    </b-row>
    <sidebar-add-new-supplier @update-prospect="getAllSupplier()" />
    <!-- <sidebar-add-payment @update-payment="" /> -->
    <sidebar-add-new-product @update-product="getAllProduct()" />
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import store from "@/store";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddPayment from "../../composants/sidebar/SidebarAddPayment.vue";
import SidebarAddNewProduct from "../../composants/sidebar/SidebarAddNewProduct.vue";
import SidebarAddNewSupplier from "../../composants/sidebar/SidebarAddNewSupplier.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { GetLinkCurrency } from "@/utils/utils.js";
import { getPriceProduct, getTotalResult } from "@/utils/utils.js";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    SidebarAddNewSupplier,
    SidebarAddPayment,
    SidebarAddNewProduct,
  },
  data() {
    return {
      salesPersonne: ["user test"],
      paymentMethods: ["Bank Account", "PayPal", "UPI Transfer"],
      nextTodoId: 2,
      AllSupplier: [],
      suppliers: [],
      supplier: "",
      allProduct: [],
      products: [],
      maxQuantity: 1,
      totalPriceDiscount: 0,
      items: [],
      noteInvoice: false,
      rateInvoice: false,
      user: {
        adress: "lorem ipsum is my location",
        ville: "tunis",
        city: "Tunisia",
        postalCode: "1000",
        PhoneNumber: "99777555",
      },
      quoteOffer: {},
      quoteData: {
        offers: {
          toAdd: {
            paymentMethod: "",
            note: "",
            paymentTerms:
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
            createdAt: new Date(),
            code: null,
            supplier: "",
            date: null,
            status: "",
            description: "",
            products: [],
            priceWithoutTaxes: 0,
            valueAddedTax: 0,
            allTaxesIncluded: 0,
            totalDiscount: 0,
            stampPrice: 0, //timbre
            warehouse: "",
            images: [],
            createdBy: JSON.parse(localStorage.getItem("userData"))._id,
          },
        },
        category: {},
        currency: "",
        /* paymentMethod: "",
        salesPersonne: "",
        note: "",
        paymentTerms:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
        code: null,
        createdAt: new Date(),
        code: null,
        supplier: "",
        date: null,
        status: "",
        description: "",
        products: [
          {
            product: "",
            quantity: 0,
            valueAddedTax: 0,
            discount: 0,
            description: "",
            quantityType: "",
          },
        ],
        priceWithoutTaxes: 0,
        valueAddedTax: 0,
        allTaxesIncluded: 0,
        totalDiscount: 0,
        stampPrice: 0, //timbre
        warehouse: "",
        images: [], */
      },
      statusOptions: [
        {
          statusName: "En cours",
          label: "in progress",
        },
        {
          statusName: "Payé",
          label: "payed",
        },
        {
          statusName: "Refusé",
          label: "refused",
        },
      ],
    };
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [heightTransition],
  // Reset Tr Height if data changes
  watch: {
    // eslint-disable-next-line func-names
    "quoteData.offers.toUpdate.items": function () {
      this.initTrHeight();
    },
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    axios
      .get(
        `https://management-projects.herokuapp.com/api/users?id=${
          JSON.parse(localStorage.getItem("userData"))._id
        }`
      )
      .then((response) => {
        this.user = response.data;
      })
      .catch((error) => console.log(error));
    this.getQuoteDetails();
    this.getAllProduct();
    this.getAllSupplier();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    //upload images
    openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "dmdd546ps", upload_preset: "jhyzlocs" },
          (error, result) => {
            if (!error && result && result.event === "success") {
              console.log("Done uploading..: ", result);
              this.url = result.info.url;
              this.publicId = result.info.public_id;
              this.quoteData.offers.toAdd.images.push(this.publicId);
            }
          }
        )
        .open();
    },
    externalUserCurrency() {
      return GetLinkCurrency();
    },
    getQuoteDetails() {
      axios
        .get(
          "https://management-projects.herokuapp.com/api/purchase-quotations/" +
            this.$router.history.current.query.id
        )
        .then((response) => {
          console.log(response.data);
          let {
            category,
            currency,
            createdBy,
            updatedBy,
            updatedAt,
            createdAt,
            _id,
            offers,
          } = response.data;
          this.quoteData.createdBy = createdBy;
          this.quoteData.createdAt = createdAt;
          this.quoteData.updatedBy = updatedBy;
          this.quoteData.updatedAt = updatedAt;
          this.quoteData.category = category;
          this.quoteData.currency = currency;
          if (this.$router.history.current.query.purchaseOffer != null) {
            // update selected purchase quotation offer
            let offerList = {
              toUpdate: offers.filter(
                (offer) =>
                  offer._id == this.$router.history.current.query.purchaseOffer
              )[0],
              others: offers.filter(
                (offer) =>
                  offer._id != this.$router.history.current.query.purchaseOffer
              ),
            };
            if (offerList.toUpdate.createdBy == null) {
              offerList.toUpdate.createdBy = JSON.parse(
                localStorage.getItem("userData")
              );
            }
            offerList.toUpdate.createdBy.fullName = `${offerList.toUpdate.createdBy.firstName} ${offerList.toUpdate.createdBy.lastName}`;
            offerList.toUpdate.supplier.firstName = `${offerList.toUpdate.supplier.firstName} ${offerList.toUpdate.supplier.lastName}`;
            this.quoteData = {
              category,
              currency,
              createdBy,
              updatedBy,
              updatedAt,
              createdAt,
              offers: offerList,
              _id,
            };
            if (
              this.quoteData.offers.toUpdate.products &&
              this.quoteData.offers.toUpdate.products.length > 0
            ) {
              this.items = this.quoteData.offers.toUpdate.products.map(
                (product) => {
                  console.log("product");
                  product.price = product.product.priceWithoutTaxes;
                  product.tax = product.valueAddedTax;
                  var newResult = getPriceProduct(product);
                  console.log("product11", newResult);
                  product.allTaxesIncluded = newResult.priceWithTax;
                  product.allTaxesIncludedWithDiscount =
                    newResult.priceWithTax - newResult.discount;
                  product.valueDiscount = newResult.discount;
                  product.valueTax = newResult.tax;
                  console.log(product);
                  console.log(product);
                  return {
                    productId: product.product._id,
                    quantity: product.quantity,
                    quantityType: product.quantityType,
                    description: product.description,
                    price: product.product.priceWithoutTaxes,
                    discount: product.product.discount,
                    tax: product.valueAddedTax,
                    name: product.product.label,
                    valueDiscount: product.valueDiscount,
                    valueTax: product.valueTax,
                    allTaxesIncludedWithDiscount:
                      product.priceWithTax - product.discount,
                    allTaxesIncluded: product.priceWithTax,
                    _id: product._id,
                  };
                }
              );
            } else {
              this.items.push({
                quantityType: "Quantité(s)",
                id: 1,
                productId: 0,
                name: {},
                price: 0,
                quantity: 1,
                discount: 0,
                valueDiscount: 0,
                tax: 0,
                valueTax: 0,
                allTaxesIncluded: 0,
                description: "",
              });
            }
          } else {
            // add offer to the purchase quotation offer list
            let offerList = {
              toAdd: {
                paymentMethod: "",
                note: "",
                paymentTerms:
                  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
                createdAt: new Date(),
                code: null,
                supplier: "",
                date: null,
                status: "",
                description: "",
                products: [
                  {
                    product: "",
                    quantity: 0,
                    valueAddedTax: 0,
                    discount: 0,
                    description: "",
                    quantityType: "",
                  },
                ],
                priceWithoutTaxes: 0,
                valueAddedTax: 0,
                allTaxesIncluded: 0,
                totalDiscount: 0,
                stampPrice: 0, //timbre
                warehouse: "",
                images: [],
              },
              others: offers,
            };
            this.quoteData.offers = offerList;
          }
          console.log(this.quoteData);
          /* this.quoteData = response.data;
          this.salesQuotationPaymentTerms =
            this.quoteData.paymentTerms != "" &&
            this.quoteData.paymentTerms != undefined;
          this.salesQuotationNote =
            this.quoteData.note != "" && this.quoteData.note != undefined;
          console.log(response.data);
          console.log(
            "get items",
            this.quoteData.products && this.quoteData.products.length > 0
          );
          if (this.quoteData.products && this.quoteData.products.length > 0) {
            this.items.oldProducts = this.quoteData.products.map((product) => {
              console.log("product");
              console.log(product);
              return {
                productId: product.product._id,
                quantity: product.quantity,
                quantityType: product.quantityType,
                description: product.description,
                price: product.product.valueAddedTax,
                discount: product.product.discount,
                tax: product.valueAddedTax,
                name: product.product.label,
                _id: product._id,
              };
            });
          } else {
            this.items.newProducts.push({
              quantityType: "Quantité(s)",
              id: 1,
              productId: 0,
              name: {},
              price: 0,
              quantity: 1,
              discount: 0,
              valueDiscount: 0,
              tax: 0,
              valueTax: 0,
              allTaxesIncluded: 0,
              description: "",
            });
          } */
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });

      /* this.items = [
        {
          quantityType: "Quantité(s)",
          id: 1,
          name: {},
          price: 0,
          quantity: 1,
          discount: 0,
          valueDiscount: 0,
          tax: 0,
          valueTax: 0,
          allTaxesIncluded: 0,
          description: "",
        },
        {
          quantityType: "Quantité(s)",
          id: 1,
          name: {},
          price: 0,
          quantity: 1,
          discount: 0,
          valueDiscount: 0,
          tax: 0,
          valueTax: 0,
          allTaxesIncluded: 0,
          description: "",
        },
      ];

      this.quoteData = {
        paymentMethod: "",
        salesperson: "user test",
        note:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
        paymentTerms:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio pariatur modi iusto officia sint, quis hic autem. Nihil officiis placeat sint est optio? Accusantium suscipit enim neque laudantium in et.",
        code: null,
        createdAt: new Date(),
        code: null,
        supplier: {
          name: "test",
          lastName: "Supplier",
          email: "clien.test@gmail.com",
          telNumbers: ["99888777"],
          address: "adresse Supplier",
          city: "tunisie",
        },
        date: null,
        status: "",
        description: "",
        products: [
          {
            product: {
              label: "produit test",
              priceWithoutTaxes: 1000,
            },
            quantity: 2,
            valueAddedTax: 5,
            discount: 10,
            description: "lorem ipsum is the best article",
            quantityType: "Quantité(s)",
          },
          {
            product: {
              label: "produit test",
              priceWithoutTaxes: 3000,
            },
            quantity: 1,
            valueAddedTax: 0,
            discount: 0,
            description: "",
            quantityType: "Heure(s) ",
          },
        ],
        priceWithoutTaxes: 1000,
        valueAddedTax: 100,
        allTaxesIncluded: 1000,
        totalDiscount: 110,
        stampPrice: 10, //timbre
        warehouse: "",
        images: [],
      }; */
    },
    updateQuote() {
      console.log("quote", this.quoteData);
      const { category, createdBy, updatedBy, ...purchaseQuotation } =
        this.quoteData;
      purchaseQuotation.updatedBy = JSON.parse(
        localStorage.getItem("userData")
      )._id;
      purchaseQuotation.createdBy = createdBy._id;
      purchaseQuotation.category = category._id;
      purchaseQuotation.offers.others = purchaseQuotation.offers.others.map(
        (offer) => offer._id
      );
      if (this.$router.history.current.query.purchaseOffer != null) {
        purchaseQuotation.offers.toUpdate.createdBy =
          this.quoteData.offers.toUpdate.createdBy._id;
        purchaseQuotation.offers.toUpdate.supplier =
          this.quoteData.offers.toUpdate.supplier._id;
        purchaseQuotation.offers.toUpdate.updatedBy = JSON.parse(
          localStorage.getItem("userData")
        )._id;
        if (this.salesQuotationNote === false) {
          purchaseQuotation.offers.toUpdate.note = "";
        }
        if (this.salesQuotationPaymentTerms === false) {
          purchaseQuotation.offers.toUpdate.paymentTerms = "";
        }
        purchaseQuotation.offers.toUpdate.products = [];
        purchaseQuotation.offers.toUpdate.products.toAdd =
          this.items.length > 0
            ? this.items.map((item) => {
                return {
                  product: item.name.id,
                  quantity: item.quantity,
                  valueAddedTax: item.tax,
                  discount: item.discount,
                  quantityType: item.quantityType,
                  description: item.description,
                };
              })
            : [];
      } else {
        purchaseQuotation.offers.toAdd.createdBy = JSON.parse(
          localStorage.getItem("userData")
        )._id;
        purchaseQuotation.offers.toAdd.supplier =
          this.quoteData.offers.toAdd.supplier.id;
        purchaseQuotation.offers.toAdd.updatedBy = JSON.parse(
          localStorage.getItem("userData")
        )._id;
        if (this.salesQuotationNote === false) {
          purchaseQuotation.offers.toAdd.note = "";
        }
        if (this.salesQuotationPaymentTerms === false) {
          purchaseQuotation.offers.toAdd.paymentTerms = "";
        }
        purchaseQuotation.offers.toAdd.products = [];
        purchaseQuotation.offers.toAdd.products =
          this.items.length > 0
            ? this.items.map((item) => {
                return {
                  product: item.name.id,
                  quantity: item.quantity,
                  valueAddedTax: item.tax,
                  discount: item.discount,
                  quantityType: item.quantityType,
                  description: item.description,
                };
              })
            : [];
      }
      console.log(JSON.stringify(purchaseQuotation));
      axios
        .put(
          `https://management-projects.herokuapp.com/api/purchase-quotations/${this.$router.history.current.query.id}`,
          purchaseQuotation
        )
        .then((response) => {
          console.log("product", response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Devis bien ajoutée",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$router.replace("/shop/quote/quote");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du Devis",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
    getAllSupplier() {
      this.suppliers = [];
      // Supplier
      axios
        .get("https://management-projects.herokuapp.com/api/suppliers")
        .then((response) => {
          this.AllSupplier = response.data;
          response.data.forEach((element) => {
            this.suppliers.push({
              name: element.firstName + " " + element.lastName,
              // company:element.company,
              address: element.address,
              city: element.city,
              email: element.email,
              telNumbers: element.telNumbers,
              id: element._id,
            });
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    getAllProduct() {
      //get all product
      this.products = [];
      axios
        .get("https://management-projects.herokuapp.com/api/products")
        .then((response) => {
          this.allProduct = response.data;
          response.data.forEach((element) => {
            this.products.push({ title: element.label, id: element._id });
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    //Supplier
    getSupplierDetail(supplier) {
      if (supplier && supplier.id) this.quoteData.supplier = supplier.id;
    },
    // add invoice start
    createInvoice() {
      var payload = {
        deletedBy: JSON.parse(localStorage.getItem("userData"))._id,
        allTaxesIncluded: data.allTaxesIncluded,
        supplier: data.supplier._id,
        date: data.date,
        description: data.description,
        priceWithoutTaxes: data.priceWithoutTaxes,
        products: data.products,
        stampPrice: data.stampPrice,
        totalDiscount: data.totalDiscount,
        valueAddedTax: data.valueAddedTax,
        warehouse: data.warehouse,
        salesCommand: data._id,
      };
      console.log(this.quoteData);
      axios
        .post(
          "https://management-projects.herokuapp.com/api/purchase-bills",
          this.quoteData
        )
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `facture bien ajoutée`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de l'ajout`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    // add invoice end
    // get product details after selection product name
    getProductDetail(item) {
      console.log("test", item, this.allProduct);
      var obj = this.allProduct.find((element) => element._id == item.name.id);
      console.log("obj", obj);
      if (obj) {
        item.price = +obj.priceWithoutTaxes;
        item.discount = +obj.discount;
        item.tax = +obj.valueAddedTax;
        if (obj.quantity) {
          this.maxQuantity = +obj.quantity;
        }
        this.getNewResult(item);
      }
    },
    // *****************************************************************************
    // get utils fn result
    getNewResult(item) {
      var newResult = getPriceProduct(item);
      item.allTaxesIncluded = newResult.priceWithTax;
      item.allTaxesIncludedWithDiscount =
        newResult.priceWithTax - newResult.discount;
      item.valueDiscount = newResult.discount;
      item.valueTax = newResult.tax;
      this.geTotalNewResult();
    },
    async geTotalNewResult() {
      console.log("item2", this.items);
      var allItems = this.items;
      console.log("this", this.items, allItems);
      console.log("item2.2", allItems);
      var newTotaleResult = await getTotalResult(allItems);
      console.log("item3", newTotaleResult);
      this.quoteData.offers.valueAddedTax = newTotaleResult.valueAddedTax;
      this.quoteData.offers.totalDiscount = newTotaleResult.valueDiscount;
      this.quoteData.offers.priceWithoutTaxes =
        newTotaleResult.priceWithoutTaxes;
      this.quoteData.offers.allTaxesIncluded = newTotaleResult.allTaxesIncluded;
      if (this.quoteData.offers.stampPrice) {
        this.quoteData.offers.allTaxesIncludedWithDiscount =
          Number.parseFloat(newTotaleResult.allTaxesIncludedWithDiscount) +
          Number.parseFloat(this.quoteData.offers.stampPrice);
      } else {
        this.quoteData.offers.allTaxesIncludedWithDiscount =
          newTotaleResult.allTaxesIncludedWithDiscount;
      }
    },
    // totalePrice(item) {
    //   item.allTaxesIncluded =
    //     this.totalePriceCommandDiscountTax(item).toFixed(3);
    //   item.allTaxesIncluded = this.totalePriceCommand(
    //     +item.allTaxesIncluded,
    //     +item.quantity
    //   );
    //   this.getTotalPrice();
    // },
    // getTotalPrice() {
    //   if (this.$router.history.current.query.purchaseOffer != null) {
    //     this.quoteData.offers.toUpdate.priceWithoutTaxes = 0;
    //     this.quoteData.offers.toUpdate.valueAddedTax = 0;
    //     this.quoteData.offers.toUpdate.allTaxesIncluded = 0;
    //     this.quoteData.offers.toUpdate.totalDiscount = 0;
    //     [...this.items.oldProducts, ...this.items.newProducts]

    //       //.filter((item) => item.name != undefined && item.name.id != undefined)
    //       .forEach((item) => {
    //         if (item.quantity == 0 || item.quantity == undefined) {
    //           item.quantity = 1;
    //         }
    //         this.quoteData.offers.toUpdate.priceWithoutTaxes +=
    //           +item.price * +item.quantity;
    //         this.quoteData.offers.toUpdate.valueAddedTax +=
    //           (item.valueTax != null ? +item.valueTax : +item.tax) *
    //           +item.quantity;
    //         this.quoteData.offers.toUpdate.allTaxesIncluded +=
    //           +item.allTaxesIncluded;
    //         console.log(
    //           this.quoteData.offers.toUpdate.totalDiscount,
    //           +item.valueDiscount,
    //           +item.quantity,
    //           typeof this.quoteData.offers.toUpdate.totalDiscount
    //         );
    //         this.quoteData.offers.toUpdate.totalDiscount +=
    //           (item.valueDiscount != null
    //             ? +item.valueDiscount
    //             : +item.discount) * +item.quantity;
    //       });
    //     this.quoteData.offers.toUpdate.allTaxesIncluded +=
    //       +this.quoteData.offers.toUpdate.stampPrice;
    //   } else {
    //     this.quoteData.offers.toAdd.priceWithoutTaxes = 0;
    //     this.quoteData.offers.toAdd.valueAddedTax = 0;
    //     this.quoteData.offers.toAdd.allTaxesIncluded = 0;
    //     this.quoteData.offers.toAdd.totalDiscount = 0;
    //     [...this.items.oldProducts, ...this.items.newProducts]

    //       //.filter((item) => item.name != undefined && item.name.id != undefined)
    //       .forEach((item) => {
    //         if (item.quantity == 0 || item.quantity == undefined) {
    //           item.quantity = 1;
    //         }
    //         this.quoteData.offers.toAdd.priceWithoutTaxes +=
    //           +item.price * +item.quantity;
    //         this.quoteData.offers.toAdd.valueAddedTax +=
    //           (item.valueTax != null ? +item.valueTax : +item.tax) *
    //           +item.quantity;
    //         this.quoteData.offers.toAdd.allTaxesIncluded +=
    //           +item.allTaxesIncluded;
    //         console.log(
    //           this.quoteData.offers.toAdd.totalDiscount,
    //           +item.valueDiscount,
    //           +item.quantity,
    //           typeof this.quoteData.offers.toAdd.totalDiscount
    //         );
    //         this.quoteData.offers.toAdd.totalDiscount +=
    //           (item.valueDiscount != null
    //             ? +item.valueDiscount
    //             : +item.discount) * +item.quantity;
    //       });
    //     this.quoteData.offers.toAdd.allTaxesIncluded +=
    //       +this.quoteData.offers.toAdd.stampPrice;
    //   }
    // },
    // getPercentage(num, per) {
    //   return (+num / 100) * +per;
    // },
    // totale price tax, discount, quantity
    // totalePriceCommandDiscountTax(product) {
    //   var totalPriceTax = 0;
    //   if (product.tax != 0 && product.tax) {
    //     product.valueTax = this.getPercentage(product.price, product.tax);
    //     totalPriceTax = +product.valueTax + +product.price;
    //   }
    //   if (product.discount != 0 && product.discount) {
    //     if (totalPriceTax != 0) {
    //       product.valueDiscount = +this.getPercentage(
    //         totalPriceTax,
    //         product.discount
    //       );
    //       return +totalPriceTax - +product.valueDiscount;
    //     } else {
    //       product.valueDiscount = +this.getPercentage(
    //         product.price,
    //         product.discount
    //       );
    //       return +product.price - +product.valueDiscount;
    //     }
    //   } else {
    //     return product.price;
    //   }
    // },
    // totalePriceCommand(productTotale, quantity) {
    //   console.log(quantity);
    //   if (quantity == undefined || quantity == 0) {
    //     return +productTotale;
    //   } else if (quantity != 0) {
    //     return +productTotale * +quantity;
    //   }
    // },
    //get total + verifiy input
    productPricingChange(item) {
      if (+item.quantity > +this.maxQuantity) {
        item.quantity = +this.maxQuantity;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Quantité maximal est " + this.maxQuantity,
            icon: "EditIcon",
            variant: "info",
          },
        });
      }
      if (item.quantity == 0 || item.quantity == undefined) {
        item.quantity = 1;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Quantité doit être supérieur à 0",
            icon: "EditIcon",
            variant: "info",
          },
        });
      }
      // this.totalePrice(item);
      // this.getTotalPrice();
    },
    addNewItemInItemForm() {
      // this.$refs.form.style.overflow = "hidden";
      // this.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)));

      // this.$nextTick(() => {
      //   this.trAddHeight(this.$refs.row[0].offsetHeight);
      //   setTimeout(() => {
      //     this.$refs.form.style.overflow = null;
      //   }, 350);
      // });
      if (this.$refs.form) {
        this.$refs.form.style.overflow = "hidden";
      }
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
        quantityType: "Quantité(s)",
        name: {},
        price: 0,
        quantity: 1,
        discount: 0,
        valueDiscount: 0,
        tax: 0,
        valueTax: 0,
        allTaxesIncluded: 0,
        allTaxesIncludedWithDiscount: 0,
        description: "",
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.geTotalNewResult();
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form ? this.$refs.form.scrollHeight : 0);
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-add-wrapper {
  .add-new-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
.select-quantity-type {
  border: none;
  background: transparent;
  color: #6e6b7b;
}
.select-quantity-type option {
  border: none !important;
  border-radius: 6px !important;
  padding: 0 !important;
  background: #fff !important;
  box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 10%) !important;
}
.invoice-total-wrapper {
  max-width: 15rem !important;
}
</style>

